/**
 * RemovableChip
 *
 * Forge input chip with a remove button, for dismissible filter indicators
 * (e.g. the Services list "Using technology" chip, issue #2097).
 */

import { useEffect, useRef } from 'react';
import '@tylertech/forge/chips';

const ForgeChipSet = 'forge-chip-set' as React.ElementType;
const ForgeChip = 'forge-chip' as React.ElementType;

export interface RemovableChipProps {
  /** Visible label. */
  label: string;
  /** Accessible name for the remove button. */
  removeLabel: string;
  /** Called when the chip's remove button is activated. */
  onRemove: () => void;
}

export function RemovableChip({ label, removeLabel, onRemove }: RemovableChipProps): JSX.Element {
  const chipRef = useRef<HTMLElement | null>(null);
  const onRemoveRef = useRef(onRemove);
  onRemoveRef.current = onRemove;

  useEffect(() => {
    const chip = chipRef.current;
    if (!chip) return undefined;
    const handler = (): void => onRemoveRef.current();
    chip.addEventListener('forge-chip-delete', handler);
    return () => chip.removeEventListener('forge-chip-delete', handler);
  }, []);

  return (
    <ForgeChipSet type="input">
      <ForgeChip ref={chipRef} type="input" remove-button-label={removeLabel}>
        {label}
      </ForgeChip>
    </ForgeChipSet>
  );
}
